<div><h4 class="border-bottom">
  {{'ClassEnrolment.LearnerDetails' | translate}}
  @if (enrolmentDto!=null && enrolmentDto.EnrolmentStatus==ENROLSTATUS.EnrolmentStatusPending) {
    <mat-label class="pending-label">
      <span class="ontario-padding-right-0-!">{{'ClassEnrolment.Pending' | translate}}</span>
    </mat-label>
  }
</h4></div>
@if (enrolmentForm) {
  <ng-container [formGroup]="enrolmentForm">
    <div class="field">
      <app-alert-banner class="field" bannerType="alert" bannerText="{{'ClassEnrolment.LearnerRecordPrivacy' | translate}}"></app-alert-banner>
    </div>
    <div class="field ontario-small-12 ontario-large-6">
      <mat-label class="input-label">
        <span class="required-field">{{'Contact.EmailAddress'| translate}}</span>
      </mat-label>
      <input autocomplete="email" type="email" class='input-text' matInput formControlName="emailAddress" required maxlength="250" (change)="checkEmail()" placeholder="{{'Contact.EmailAddressTooltip' | translate}}" />
      @if ((enrolmentForm.controls['emailAddress'].invalid &&  enrolmentForm.controls['emailAddress'].errors && (enrolmentForm.controls['emailAddress'].dirty || enrolmentForm.controls['emailAddress'].touched))) {
        <div>
          @if (enrolmentForm.controls['emailAddress'].hasError('exists')) {
            <mat-error>
              {{'CreateClassroom.Validation.EmailAddressExists' | translate}}
            </mat-error>
          }
          @if (enrolmentForm.controls['emailAddress'].hasError('pattern')) {
            <mat-error>
              {{'Validation.Email.Pattern' | translate}}
            </mat-error>
          }
          @if (enrolmentForm.controls['emailAddress'].hasError('required')) {
            <mat-error>
              {{'Validation.Email.Required2' | translate}}
            </mat-error>
          }
        </div>
      }
    </div>
    <div class="field ontario-small-12 ontario-large-6">
      <mat-label class="input-label">
        <span class="required-field">{{'Contact.FirstName' | translate}}</span>
      </mat-label>
      <input autocomplete="given-name" type="text" class='input-text' matInput formControlName="firstName" required  maxlength="250" (change)="update()" placeholder="{{'Contact.FirstNameTooltip' | translate}}" />
      @if ((enrolmentForm.controls['firstName'].invalid &&  enrolmentForm.controls['firstName'].errors && (enrolmentForm.controls['firstName'].dirty || enrolmentForm.controls['firstName'].touched))) {
        <div>
          @if (enrolmentForm.controls['firstName'].hasError('required')) {
            <mat-error>
              {{'Validation.FirstName.Required' | translate}}
            </mat-error>
          }
          @if (enrolmentForm.controls['firstName'].hasError('maxlength')) {
            <mat-error>
              {{'Validation.FirstName.MaxLength' | translate}}
            </mat-error>
          }
        </div>
      }
    </div>
    <div class="field ontario-small-12 ontario-large-6">
      <mat-label class="input-label">
        <span class="required-field">{{'Contact.LastName' | translate}}</span>
      </mat-label>
      <input autocomplete="family-name" type="text" class='input-text' matInput formControlName="lastName" required  maxlength="250" (change)="update()" placeholder="{{'Contact.LastNameTooltip' | translate}}" />
      @if ((enrolmentForm.controls['lastName'].invalid &&  enrolmentForm.controls['lastName'].errors && (enrolmentForm.controls['lastName'].dirty || enrolmentForm.controls['lastName'].touched))) {
        <div>
          @if (enrolmentForm.controls['lastName'].hasError('required')) {
            <mat-error>
              {{'Validation.LastName.Required' | translate}}
            </mat-error>
          }
          @if (enrolmentForm.controls['lastName'].hasError('maxlength')) {
            <mat-error>
              {{'Validation.LastName.MaxLength' | translate}}
            </mat-error>
          }
        </div>
      }
    </div>
    <div class="field ontario-small-12 ontario-large-6">
      <mat-label class="input-label">
        <span class="required-field">{{'ClassEnrolment.Phone' | translate}}</span>
        <app-tooltip [tooltipText]="'ClassEnrolment.PhoneIconTooltip' | translate" tabindex="-1"></app-tooltip>
      </mat-label>
      <input autocomplete="tel" type="text" mask="000-000-0000" class='input-text' matInput formControlName="phone" (change)="update()" required placeholder="{{'Contact.PhoneTooltip' | translate}}" />
      @if ((enrolmentForm.controls['phone'].invalid &&  enrolmentForm.controls['phone'].errors && (enrolmentForm.controls['phone'].dirty || enrolmentForm.controls['phone'].touched))) {
        <div>
          @if (enrolmentForm.controls['phone'].hasError('pattern')) {
            <mat-error>
              {{'Validation.Phone.Pattern' | translate}}
            </mat-error>
          }
          @if (enrolmentForm.controls['phone'].hasError('required')) {
            <mat-error>
              {{'Validation.Phone.Required' | translate}}
            </mat-error>
          }
        </div>
      }
    </div>
    <div class="field ontario-small-12 ontario-large-6">
      <mat-label class="input-label">
        <span class="required-field">{{'ClassEnrolment.BirthYear' | translate}}</span>
        <app-tooltip [tooltipText]="'ClassEnrolment.BirthYear' | translate" tabindex="-1"></app-tooltip>
      </mat-label>
      <input autocomplete="bday-year" type="text" mask="0000" class='input-text' matInput min="1950" max="2050" formControlName="birthYear" (change)="update()" placeholder="{{'ClassEnrolment.EnterBirthYear' | translate}}" />
      @if ((enrolmentForm.controls['birthYear'].invalid &&  enrolmentForm.controls['birthYear'].errors && (enrolmentForm.controls['birthYear'].dirty || enrolmentForm.controls['birthYear'].touched))) {
        <div>
          @if (enrolmentForm.controls['phone'].hasError('pattern') || enrolmentForm.controls['phone'].hasError('required')) {
            <mat-error>
              {{'Validation.BirthYear.Pattern' | translate}}
            </mat-error>
          }
        </div>
      }
    </div>
    <div class="field ontario-small-12 ontario-large-6">
      <mat-label class="input-label">
        <span>{{'ClassEnrolment.AddressPostalCode' | translate}}</span>
      </mat-label>
      <input type="text" class='input-text' matInput formControlName="address"  maxlength="500" (change)="update()" placeholder="{{'ClassEnrolment.EnterAddressPostalCode' | translate}}" />
    </div>
    <div class="field ontario-small-12 ontario-large-12">
      <div class="message-box">
        <mat-label class="input-label">
          <span>{{'ClassEnrolment.Note' | translate}}</span>
        </mat-label>
        <div class="message-input">
          <textarea class='input-text' matInput formControlName="note" (change)="update()" placeholder="{{'ClassEnrolment.EnterNote' | translate}}"></textarea>
        </div>
      </div>
    </div>
  </ng-container>
}
